var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Popup',{attrs:{"title":"活动规则","visible":_vm.visible,"message":[],"showConfirmButton":false},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('div',{staticClass:"rule_wrap"},[_vm._v(_vm._s(_vm.ruleText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }